.table-head-cell {
  border-bottom: 0.1rem solid var(--color-grayscale-tuna);

  &:first-child,
  &:last-child {
    padding-inline-start: 1.6rem;
  }
}

.parking-instructions {
  border-radius: 0.4rem;
  font-weight: 400;
  font-size: 1.4rem;
  color: var(--color-grayscale-white);
  margin-inline-start: -0.8rem;

  &::placeholder {
    color: var(--color-grayscale-light-slate);
  }

  &:hover {
    background-color: var(--color-grayscale-arsenic);
  }

  &:focus {
    background-color: transparent !important;
    border-color: var(--color-grayscale-trout);
  }
}
